export default {
    controleFrotas: [],
    controleFrota: {}
}